import { restDelete, restGet, restPost } from "./restClient.js";

const CURRENT = "/v1/perplexity-audit-integrations/current";

export function getPerplexityAuditIntegration() {
    return restGet(CURRENT);
}

export function createPerplexityAuditIntegration() {
    return restPost("/v1/perplexity-audit-integrations", {});
}

export function rotatePerplexityAuditCredential() {
    return restPost(`${CURRENT}:rotate-credential`, {});
}

export function deletePerplexityAuditIntegration() {
    return restDelete(CURRENT);
}
